/* No Es Que No Escuche · theme.js (vanilla, sin dependencias). Todo es mejora progresiva: sin JS la página funciona. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Apariciones suaves al hacer scroll (desactivadas con «reducir movimiento» o desde el theme) */
  if (document.body.classList.contains('has-animations') && !reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* 2. CTA fijo: aparece después del hero y se oculta cuando hay una caja de oferta, el cierre o el footer en pantalla.
        Publica «is-past-hero» en <body>: en mobile la barra superior retira su botón (una sola CTA fija por vez). */
  const sticky = document.querySelector('[data-sticky-cta]');
  if (sticky) {
    document.body.classList.add('has-sticky-cta');
    if (sticky.classList.contains('sticky-cta--desktop')) document.body.classList.add('has-sticky-desktop');
    const hero = document.querySelector('[data-hero]');
    const hiders = document.querySelectorAll('[data-sticky-hide], .site-footer');
    let pastHero = !hero;
    const visibleHiders = new Set();
    const update = () => {
      document.body.classList.toggle('is-past-hero', pastHero);
      const show = pastHero && visibleHiders.size === 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelectorAll('a, button').forEach((el) => (el.tabIndex = show ? 0 : -1));
    };
    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(([e]) => {
          pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
          update();
        }).observe(hero);
      }
      const hio = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? visibleHiders.add(e.target) : visibleHiders.delete(e.target)));
        update();
      }, { threshold: 0 , rootMargin: '0px 0px -12% 0px' });
      hiders.forEach((el) => hio.observe(el));
    } else {
      pastHero = true;
    }
    update();
  }

  /* 3. Evitar doble envío del botón de compra */
  document.addEventListener('submit', (ev) => {
    const form = ev.target.closest('[data-cta-form] form');
    if (!form || ev.defaultPrevented) return;
    const btn = form.querySelector('button[type="submit"]');
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') {
        ev.preventDefault();
        return;
      }
      btn.setAttribute('aria-busy', 'true');
      setTimeout(() => btn.removeAttribute('aria-busy'), 8000);
    }
  });

  /* 4. Medición: cada CTA dispara un evento con su ubicación (hero, offer, sticky…).
        Listo para conectar con Customer Events / dataLayer. No instala ningún pixel. */
  document.addEventListener('click', (ev) => {
    const cta = ev.target.closest('[data-cta]');
    if (!cta) return;
    const detail = { location: cta.dataset.ctaLocation || 'unknown' };
    document.dispatchEvent(new CustomEvent('neqne:cta-click', { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'cta_click', cta_location: detail.location });
  });

  /* 5. Carrusel: botones anterior / siguiente (el swipe es nativo con scroll-snap) */
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 300);
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));

    /* Puntos (si el carrusel los tiene) + ocultar controles cuando todo entra en pantalla. Sin autoplay. */
    const dotsBox = root.querySelector('[data-carousel-dots]');
    const slides = [...track.children];
    let dots = [];
    if (dotsBox && slides.length > 1) {
      dots = slides.map((slide, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel__dot';
        b.tabIndex = -1; // el track ya se navega con teclado (flechas); los puntos son ayuda visual y táctil
        b.addEventListener('click', () => track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).scrollPaddingLeft || 0), behavior: reduceMotion ? 'auto' : 'smooth' }));
        dotsBox.appendChild(b);
        return b;
      });
    }
    const sync = () => {
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
      if (!dots.length) return;
      const x = track.scrollLeft + 1;
      let active = 0;
      slides.forEach((s, i) => { if (s.offsetLeft - track.offsetLeft - 24 <= x) active = i; });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) active = slides.length - 1;
      dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* 5b. Medición de acciones (ver mensaje completo, link a la garantía…): data-action → evento + dataLayer */
  document.addEventListener('click', (ev) => {
    const el = ev.target.closest('[data-action]');
    if (!el) return;
    const section = el.closest('[data-section]')?.dataset.section || 'unknown';
    document.dispatchEvent(new CustomEvent('neqne:action', { detail: { action: el.dataset.action, section } }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'landing_action', action: el.dataset.action, section });
  });

  /* 5c. Mensaje completo: <dialog> nativo (ESC cierra, fondo inerte). Sin JS, el link abre la imagen. */
  document.querySelectorAll('[data-review-dialog]').forEach((dialog) => {
    if (typeof dialog.showModal !== 'function') return;
    const img = dialog.querySelector('img');
    const closeBtn = dialog.querySelector('[data-review-close]');
    let opener = null;
    dialog.closest('[data-section]').addEventListener('click', (ev) => {
      const link = ev.target.closest('[data-action="review-expand"]');
      if (!link) return;
      ev.preventDefault();
      opener = link;
      img.src = link.dataset.full;
      img.alt = link.dataset.alt || '';
      dialog.showModal();
      document.documentElement.classList.add('has-dialog');
      dialog.scrollTop = 0;
      closeBtn.focus();
    });
    closeBtn.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (ev) => { if (ev.target === dialog) dialog.close(); }); // tocar el fondo
    dialog.addEventListener('keydown', (ev) => { if (ev.key === 'Tab') { ev.preventDefault(); closeBtn.focus(); } }); // foco atrapado
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('has-dialog');
      opener?.focus();
    });
  });
})();

/* 6. Oferta con cuenta regresiva (Configuración del theme → Oferta por tiempo limitado). Dos modos:
      - Precio de bienvenida: X minutos desde la PRIMERA visita de cada persona (guardado en su navegador, no se
        reinicia al recargar). Mientras corre: se muestra el precio de bienvenida y todos los links de compra llevan
        ?discount=CÓDIGO (Shopify lo aplica en el checkout). Al vencer: precio normal y links sin código. Para siempre.
      - Fecha real: una fecha de fin igual para todos.
      En los dos casos la cuenta empieza oculta y desaparece al vencer. Nunca se reinicia. */
(() => {
  const code = document.body.dataset.welcomeCode || '';
  const minutes = parseInt(document.body.dataset.welcomeMinutes || '0', 10);
  const KEY = 'neqne_welcome_start';
  const inEditor = !!(window.Shopify && window.Shopify.designMode);
  const read = (store) => { try { return parseInt(store.getItem(KEY), 10) || 0; } catch (e) { return 0; } };
  const write = (store, v) => { try { store.setItem(KEY, String(v)); return true; } catch (e) { return false; } };

  let welcomeEnd = NaN;
  if (code && minutes > 0) {
    // En el editor de Shopify se usa la sesión (para ver el contador mientras editás); en la tienda, el navegador.
    let store = null;
    try { store = inEditor ? window.sessionStorage : window.localStorage; } catch (e) { store = null; }
    let start = store ? read(store) : 0;
    if (!start) { start = Date.now(); if (store) write(store, start); }
    welcomeEnd = start + minutes * 60000;
  }

  const withCode = (url, on) => {
    try {
      const u = new URL(url, location.origin);
      if (on) u.searchParams.set('discount', code); else u.searchParams.delete('discount');
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  };
  let welcomeOn = null;
  const setWelcome = (on) => {
    if (on === welcomeOn) return;
    welcomeOn = on;
    document.documentElement.classList.toggle('welcome-on', on);
    document.querySelectorAll('a[href*="/cart/"]').forEach((a) => {
      const href = a.getAttribute('href');
      if (/\/cart\/\d+:\d/.test(href)) a.setAttribute('href', withCode(href, on));
    });
    document.querySelectorAll('[data-bump]').forEach((b) => { b.dataset.bumpUrl = withCode(b.dataset.bumpUrl, on); });
    document.querySelectorAll('input[name="return_to"]').forEach((i) => { if (i.value.indexOf('/checkout') === 0) i.value = withCode(i.value, on); });
    document.dispatchEvent(new CustomEvent('neqne:welcome', { detail: { active: on } }));
  };
  // Carrito: si la oferta sigue vigente, «Finalizar compra» va al checkout con el código.
  document.addEventListener('submit', (ev) => {
    if (!welcomeOn || !ev.target.matches('[data-cart-form]')) return;
    if (ev.submitter && ev.submitter.name !== 'checkout') return;
    ev.preventDefault();
    window.location.href = withCode('/checkout', true);
  });

  const els = [...document.querySelectorAll('[data-countdown]')];
  const pad = (n) => String(n).padStart(2, '0');
  let timer = null;
  const tick = () => {
    const now = Date.now();
    if (code) setWelcome(Number.isFinite(welcomeEnd) && welcomeEnd > now);
    let running = code && welcomeEnd > now;
    els.forEach((el) => {
      const end = el.hasAttribute('data-welcome') ? welcomeEnd : Date.parse(el.dataset.end);
      const left = end - now;
      if (!Number.isFinite(end) || left <= 0) { el.hidden = true; return; }
      running = true;
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      el.querySelector('[data-cd-d]').textContent = d;
      el.querySelector('[data-cd-h]').textContent = pad(h);
      el.querySelector('[data-cd-m]').textContent = pad(Math.floor((s % 3600) / 60));
      el.querySelector('[data-cd-s]').textContent = pad(s % 60);
      el.querySelector('[data-cd-days]').hidden = d === 0;
      // Menos de una hora: formato 14:59 (sin horas)
      const noHours = d === 0 && h === 0;
      el.querySelector('[data-cd-hours]').hidden = noHours;
      el.querySelector('[data-cd-hours-sep]').hidden = noHours;
      el.hidden = false;
    });
    if (!running && timer) { clearInterval(timer); timer = null; }
  };
  tick();
  if (els.length || code) timer = setInterval(tick, 1000);
})();

/* 7. Order bump: si la casilla del programa de 30 días está marcada, el botón compra los 2 productos juntos
      (link de carrito /cart/EBOOK:1,PROGRAMA:1 → checkout). Sin marcar, funciona como siempre. */
(() => {
  const go = (unit, ev) => {
    const bump = unit.querySelector('[data-bump]');
    if (!bump || !bump.checked) return;
    ev.preventDefault();
    window.location.href = bump.dataset.bumpUrl;
  };
  document.addEventListener('submit', (ev) => {
    const unit = ev.target.closest('[data-cta-unit]');
    if (unit) go(unit, ev);
  }, true);
  document.addEventListener('click', (ev) => {
    const link = ev.target.closest('[data-cta-unit] a[data-cta]');
    if (link) go(link.closest('[data-cta-unit]'), ev);
  }, true);
  document.addEventListener('change', (ev) => {
    if (!ev.target.matches('[data-bump]')) return;
    const unit = ev.target.closest('[data-cta-unit]');
    unit?.classList.toggle('has-bump', ev.target.checked);
    document.dispatchEvent(new CustomEvent('neqne:bump', { detail: { checked: ev.target.checked } }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'order_bump_toggle', checked: ev.target.checked });
  });
})();

/* 8. Paso de upsell antes del checkout: al tocar «Quiero la guía» se ofrece sumar el programa de 30 días.
      «Sí» = guía + programa · «No, gracias» = solo la guía (y no se vuelve a ofrecer en esa visita).
      Los botones que ya compran el combo (opción 2, casilla marcada) no pasan por este paso. */
(() => {
  const dialog = document.querySelector('[data-upsell-step]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const KEY = 'neqne_upsell_declined';
  const declined = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const yes = dialog.querySelector('[data-upsell-choice="yes"]');
  const no = dialog.querySelector('[data-upsell-choice="no"]');
  let opener = null;

  const isGuideOnly = (el) => !!el && !el.hasAttribute('data-bundle') && !el.closest('[data-upsell-step]');
  const open = (from) => {
    opener = from;
    dialog.showModal();
    document.documentElement.classList.add('has-dialog');
    yes.focus();
    const where = (from && from.dataset.ctaLocation) || 'unknown';
    document.dispatchEvent(new CustomEvent('neqne:upsell-step', { detail: { location: where } }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'upsell_step_view', cta_location: where });
  };
  // Links (modo «directo al checkout»)
  document.addEventListener('click', (ev) => {
    const cta = ev.target.closest('a[data-cta]');
    if (ev.defaultPrevented || !isGuideOnly(cta) || declined()) return;
    ev.preventDefault();
    open(cta);
  }, true);
  // Formularios (modos «agregar al carrito»)
  document.addEventListener('submit', (ev) => {
    const form = ev.target.closest('[data-cta-form] form');
    if (ev.defaultPrevented || !form || declined()) return;
    const btn = form.querySelector('[data-cta]');
    if (!isGuideOnly(btn)) return;
    ev.preventDefault();
    open(btn);
  }, true);

  no.addEventListener('click', () => { try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* sin almacenamiento: se vuelve a ofrecer */ } });
  dialog.querySelector('[data-upsell-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (ev) => { if (ev.target === dialog) dialog.close(); }); // tocar el fondo
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('has-dialog');
    if (opener) opener.focus();
  });
})();
